import debounce from '../commons/helpers/debounce';

const { $ } = window;

const YurPlanWidgets = {
    EVENT_TYPES: {
        AUTO_HEIGHT: 'autoHeight',
        CHANGE_STEP: 'changeStep',
        SCROLL_IFRAME: 'scrollIframe',
    },
    STEPS: {
        TICKETS: 'tickets',
        FORM: 'form',
        PRODUCTS: 'products',
        CONFIRMATION: 'confirmation',
        SUMMARY: 'summary',
    },
};

function widgetSendInfoToPage(type) {
    const el = $('#yurplan-widget-body');
    const height = el.outerHeight(true);
    const { widgetConfiguration } = window;

    widgetConfiguration.height = height;
    widgetConfiguration.step = el.data('step');

    try {
        window.parent.postMessage({
            id: el.data('id'),
            data: widgetConfiguration,
            type,
        }, '*');
    } catch (e) {
        /* eslint-disable-next-line no-console */
        console.log('Failed postMessage to window.parent', e);
    }
}

$(() => {
    const widgetBody = document.getElementById('yurplan-widget-body');
    const widgetContainer = $(widgetBody).find('.widget');
    const displayLoader = () => widgetContainer.css('opacity', 0.6);

    if (widgetBody) {
        // Options for the observer (which mutations to observe)
        const config = {
            attributes: true,
            childList: true,
            subtree: true,
        };
        const triggerAutoHeightCallback = debounce(
            widgetSendInfoToPage.bind(
                null,
                YurPlanWidgets.EVENT_TYPES.AUTO_HEIGHT,
            ),
            300,
        );
        // Create an observer instance linked to the callback function
        const domSubtreeObserver = new MutationObserver((mutationsList) => {
            const skipEvent = mutationsList.every(mutation => mutation.target.className.indexOf('ticketing_timer_update') > -1);
            if (skipEvent) return;
            triggerAutoHeightCallback();
        });

        // Start observing the target node for configured mutations
        domSubtreeObserver.observe(widgetBody, config);
        // Also watch resize event
        $(window).on('resize load', triggerAutoHeightCallback);
    }

    // Disable autoscroll for first step and orga widget
    if ($(widgetBody).data('step') !== YurPlanWidgets.STEPS.TICKETS && !$('body').data('widget_parent_id')) {
        widgetSendInfoToPage(YurPlanWidgets.EVENT_TYPES.SCROLL_IFRAME);
    }

    widgetSendInfoToPage(YurPlanWidgets.EVENT_TYPES.CHANGE_STEP);

    $(widgetContainer).on('click', 'a.toDisabled', displayLoader);

    $(widgetContainer).on('submit', 'form:not(.ajax)', function displayLoaderOnFormSubmit(e) {
        e.preventDefault();
        const submit = $(this).find('input[type=submit], button[type=submit]');
        submit.attr('disabled', true);
        submit.val(`${submit.val()} ...`);
        displayLoader();
        this.submit();
    });

    // Display signin form
    $(widgetContainer).on('click', '.widget-connect-me', (e) => {
        e.preventDefault();
        $('.widget-register').hide();
        $('.widget-login').show();
        $('.no-account').hide();
    });

    // Display signup form
    $(widgetContainer).on('click', '.back-to-register', (e) => {
        e.preventDefault();
        $('.widget-register').show();
        $('.widget-login').hide();
        $('.no-account').show();
    });
});
